/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Search_LabelInputs */

const vi_customer_search_label = /** @type {(inputs: Customer_Search_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm`)
};

/**

* @param {Customer_Search_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_search_label = /** @type {((inputs?: Customer_Search_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Search_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_search_label(inputs)
});